import { MdNotifications } from 'react-icons/md';
import { LoadingMode } from '../Components/LoadingMode';
import { formatDateStrToDate } from '../utils';
import { useNotifications } from '../Hooks/useNotifications';

function Notifications() {
  const {
    isLoading,
    notifications,
    handleClearNotification,
    isSubmiting,
    goToNotification,
  } = useNotifications();

  return (
    <section className='text-p-bk'>
      <div className='flex flex-row gap-3 justify-center items-center py-12 bg-f-bk mb-12 text-2xl '>
        <MdNotifications />
        <h2>Notifications</h2>
      </div>
      {isLoading ? (
        <LoadingMode />
      ) : notifications.length === 0 ? (
        <div className='w-[90%] h-full flex items-center justify-center'>
          <h2 className='font-semibold text-xl'>No Notifications</h2>
        </div>
      ) : (
        <div className='w-[90%] flex flex-row gap-6 p-6 mx-auto'>
          <div className=' py-2 w-full '>
            <div className='flex flex-row justify-between pb-4 border-b-hf mb-6 items-end'>
              <h3 className='font-semibold text-[18px]'>All Messages</h3>
              <button
                type='button'
                className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 h-fit px-6 py-2 w-fit disabled:bg-b-mct bg-b-mc rounded relative'
                onClick={handleClearNotification}
                // disabled={isSubmiting}
              >
                Clear all
                {isSubmiting && <LoadingMode />}
              </button>
            </div>

            {notifications?.map((notification) => (
              <div
                key={notification.id}
                className={`flex flex-row gap-4  shadow px-4 mb-4 py-4 w-full rounded cursor-pointer hover:bg-b-mc ${
                  notification.status === '0'
                    ? 'bg-b-mct text-p-bk'
                    : 'bg-p-wh text-s-bk'
                }`}
                onClick={() => goToNotification(notification.id)}
              >
                <span className='px-4 py-2 rounded h-fit bg-orange-500 text-p-wh mt-1'>
                  {notification.title.split(' ')[0][0]}
                </span>
                <div className='w-full'>
                  <h4 className='font-semibold flex justify-between items-center pb-2'>
                    {notification?.title}
                    <span className='text-xs '>
                      {formatDateStrToDate(notification?.created_at)}
                    </span>
                  </h4>
                  <p className='text-sm '>{notification?.message}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}

export default Notifications;
